import React, { useState, useEffect } from "react";
import moment from "moment";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import { Badge, IconButton, Menu, MenuItem } from "@mui/material";
import ViewGroupDialog from "./ViewGroupDialog";
import EmployeesByGroupDialog from "./EmployeesByGroupDialog";
const ITEM_HEIGHT = 60;
const GroupCard = (props) => {
  const { user, request, index } = props;
  const { hasPermissions } = useRequiredAuth();
  const [showGroupDialog, setShowGroupDialog] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const open = Boolean(anchorEl);
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  // Close dialog
  const handleCloseDetails = () => {
    setIsDetailsOpen(false);
  };
  return (
    <>
      <tr className="appeal-hovered">
        <td className="text-left">
          <strong> {index} </strong>
        </td>
        <td className="text-left text-truncate">{request.name}</td>
        <td className="text-left text-truncate">{request.fiscalYear}</td>
        <td className="text-center text-truncate">{request.totalUnits}</td>
        <td className="text-center text-truncate">
          {request.votedEmployees}/{request.totalEmployees}
        </td>

        <td className="text-right">
          {moment(request.openingDate).format("ll")}
        </td>
        <td className="text-right">
          {moment(request.closingDate).format("ll")}
        </td>
        <td className="text-right">{moment(request.createdOn).format("ll")}</td>
        <td className="text-center">
          {!!request.isPublished ? (
            <span className="badge badge-success px-2 py-1">Published</span>
          ) : (
            <span className="badge badge-secondary px-2 py-1">In-progress</span>
          )}
        </td>
        <td className="text-center">
          <IconButton
            size="small"
            onClick={handleOpenMenu}
            // onMouseMove={handleOpenMenu}
            aria-label="settings"
          >
            <Badge color="info">
              <span className="material-icons">more_vert</span>
            </Badge>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleCloseMenu}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "auto",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                maxHeight: ITEM_HEIGHT * 4.5,
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 2,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 15,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <span>
              <MenuItem
                onClick={() => {
                  handleCloseMenu();
                  setShowGroupDialog(true);
                }}
                className="text-dark font-weight-light"
              >
                View Group
              </MenuItem>
            </span>

            <span>
              <MenuItem
                onClick={() => {
                  handleCloseMenu();
                  setIsDetailsOpen(true);
                }}
                className="text-dark font-weight-light"
              >
                View Employees
              </MenuItem>
            </span>
          </Menu>
        </td>
      </tr>
      {showGroupDialog && (
        <ViewGroupDialog
          enableToDelete={true}
          group={request}
          showGroupDialog={showGroupDialog}
          setShowGroupDialog={setShowGroupDialog}
        />
      )}
      {isDetailsOpen && (
        <EmployeesByGroupDialog
          open={isDetailsOpen}
          onClose={handleCloseDetails}
          group={request}
        />
      )}
    </>
  );
};
export default GroupCard;
